import PropTypes from "prop-types";
import React from "react";
import { Link } from "react-router-dom";
import __ from "src/utils/Translations";

const AnchorTag = ({ href, to, id, isTargetBlank, children, dataTestId }) =>
  href ? (
    <a
      href={href}
      className="link-unstyled"
      data-t1={`${id}Tile`}
      data-testid={dataTestId}
      target={isTargetBlank ? "_blank" : "_self"}
      rel={isTargetBlank ? "noreferrer noopener" : undefined}
    >
      {children}
    </a>
  ) : (
    <Link
      to={to}
      className="link-unstyled"
      data-t1={`${id}Tile`}
      data-testid={dataTestId}
    >
      {children}
    </Link>
  );

AnchorTag.propTypes = {
  href: PropTypes.string,
  to: PropTypes.string,
  id: PropTypes.string.isRequired,
  isTargetBlank: PropTypes.bool,
  children: PropTypes.node.isRequired,
  dataTestId: PropTypes.string,
};

AnchorTag.defaultProps = {
  href: "",
  to: "",
  isTargetBlank: false,
  dataTestId: undefined,
};

export default AnchorTag;
